<template>
  <BaseModal
    :activeModal="show"
    @closeModal="$emit('close')"
    :cancel="true"
    :ok="true"
    okLabel="wyłącz"
    okClass="btn-danger"
    @ok="disable"
    :close="false"
    :bgClose="false"
    size="sm"
  >
    <template #header>
      Wyłączenie autoryzacji dwuetapowej
    </template>

    <template #default>
      <p class="text-sm text-gray-600 mb-3">
        Czy na pewno chcesz wyłączyć autoryzację dwuetapową?
      </p>

      <p class="text-sm text-red-600 font-semibold mb-4">
        Obniży to poziom bezpieczeństwa Twojego konta.
      </p>

      <div class="mb-3">
        <label class="block text-sm font-semibold text-gray-600 mb-1">
          Potwierdź hasłem
        </label>
        <input
          v-focus
          v-model="form.password"
          type="password"
          @keyup.enter="disable"
          :class="{ 'border-red-300': error !== null }"
        >
      </div>

      <p v-if="error" class="text-red-500 text-sm">
        {{ error }}
      </p>
    </template>
  </BaseModal>
</template>

<script>
import TwoFactorService from '../services/TwoFactorService';

export default {
  name: 'UserTwoFactorDisable',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      form: {
        password: '',
      },
      error: null,
    };
  },
  mounted() {
    this.show = true;
  },
  methods: {
    disable() {
      this.error = null;

      if (!this.form.password) {
        this.error = 'Hasło jest wymagane';
        return;
      }

      TwoFactorService.disableTwoFactor({
        password: this.form.password,
      })
        .then(() => {
          this.$emit('disabled');
          this.show = false;
        })
        .catch(() => {
          this.error = 'Nieprawidłowe hasło lub nie udało się wyłączyć autoryzacji';
        });
    },
  },
};
</script>
